<template>
    <div class="login w-100 d-flex">
        <section class="bg-blur auth col-12 mx-auto align-self-md-center col-md-7 col-xl-4 col-xxl-4">
            <div class="half-design row">
                <div class="col-12 form-block">
                    <div class="logo col-auto p-0">
                        <img src="@/assets/logo_full.svg" alt="logo" height="70px" class="mx-auto" />
                    </div>

                    <div class="col-12 col-md-10 mx-auto mt-3">
                        <b-form @submit.prevent="verifyOtp">
                            <div class="mb-3 text-left d-flex justify-content-center">
                                <label class="mb-1" for="otp">{{ $t('title.otp') }}</label>
                            </div>
                            <div class="d-flex justify-content-between mb-3">
                                <b-form-input
                                    v-for="(digit, index) in otpFields"
                                    :key="index"
                                    type="text"
                                    maxlength="1"
                                    class="otp-input text-center"
                                    v-model="otpFields[index]"
                                    @input="onOtpInput(index)"
                                    @focus="onFocus(index)"
                                    @keydown.backspace="onOtpDelete(index)"
                                    @paste="onPaste"
                                    :disabled="loader"
                                    :ref="`otp-${index}`"
                                />
                            </div>
                            <b-form-invalid-feedback v-if="formErrors.otp">
                                {{ formErrors.otp }}
                            </b-form-invalid-feedback>

                            <div id="recaptcha-container">
                                <div
                                    class="g-recaptcha"
                                    :data-sitekey="recaptchaSiteKey"
                                    data-callback="onRecaptchaSuccess"
                                    data-error-callback="onRecaptchaError"
                                    data-expired-callback="onRecaptchaExpired"
                                ></div>
                            </div>
                            <b-form-invalid-feedback v-if="captchaError" style="display: block;">
                                {{ captchaError }}
                            </b-form-invalid-feedback>


                            <b-button type="submit" variant="primary" class="mt-3 w-100" :disabled="loader">
                                <div class="spinner-border spinner-border-sm text-light" role="status" v-if="loader"></div>
                                {{ $t('title.verify_otp') }}
                            </b-button>

                            <b-button variant="danger" class="w-100 mt-2" @click="clearOtp">
                                Clear OTP
                            </b-button>

                            <b-button variant="link" class="w-100" @click="resendOtp" :disabled="countdown > 0">
                                {{ countdown > 0 ? `Resend OTP in ${countdown}s` : 'Resend OTP' }}
                            </b-button>

                            <b-form-invalid-feedback v-if="formErrors.general">
                                {{ formErrors.general }}
                            </b-form-invalid-feedback>
                        </b-form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import Error from "@/Util/Error";
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import commonMixin from "@/Util/commonMixin";


export default {
    mixins: [commonMixin],
    data() {
        return {
            otpFields: Array(6).fill(''),
            email: this.$route.query.email || '',
            formErrors: new Error({}),
            countdown: 180,
            interval: null,
            failedAttempts:0,
            recaptchaToken: '',
            captchaError: null,
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        };
    },
    computed: {
        ...mapGetters(['loader']),
    },

    methods: {
        onVerify(token) {
            this.recaptchaToken = token;
            this.formFields['g-recaptcha-response'] = token;
            this.captchaError = "";
        },
        onError() {
            this.recaptchaToken = '';
            this.captchaError = "reCAPTCHA error occurred. Please try again";
            this.resetCaptcha();
        },
        onExpired() {
            this.recaptchaToken = '';
            this.captchaError = "CAPTCHA expired. Please verify again.";
            this.resetCaptcha();
        },
        waitForRecaptchaReady(callback) {
            const interval = setInterval(() => {
                if (window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render) {
                    clearInterval(interval);
                    callback();
                }
            }, 100);
        },
        resetCaptcha(){
            this.$nextTick(() => {
                const container = document.getElementById("recaptcha-container");
                if (container) {
                    container.innerHTML = ''; // remove old captcha
                    const newDiv = document.createElement('div');
                    newDiv.className = 'g-recaptcha';
                    newDiv.setAttribute('data-sitekey', this.recaptchaSiteKey);
                    newDiv.setAttribute('data-callback', 'onRecaptchaSuccess');
                    newDiv.setAttribute('data-error-callback', 'onRecaptchaError');
                    newDiv.setAttribute('data-expired-callback', 'onRecaptchaExpired');
                    container.appendChild(newDiv);

                    this.waitForRecaptchaReady(() => {
                        window.grecaptcha.enterprise.render(newDiv);
                    });

                }
            });
        },
        clearOtp() {
            this.otpFields = Array(6).fill('');
            this.$nextTick(() => {
                this.$refs['otp-0'][0]?.focus();
            });
        },
        onOtpDelete(index) {
            if (this.otpFields[index] === '' && index > 0) {
                this.$nextTick(() => {
                    this.$refs[`otp-${index - 1}`][0].focus();
                });
            }
        },
        validateOtp() {
            const otp = this.otpFields.join('');
            if (otp.length !== 6 || !/^\d{6}$/.test(otp)) {
                this.formErrors = new Error({ otp: ['OTP must be 6 digits'] });
            } else {
                this.formErrors = new Error({});
            }
        },
        onOtpInput(index) {
            this.validateOtp();
            if (this.otpFields[index].length === 1 && index < 5) {
                this.$nextTick(() => {
                    this.$refs[`otp-${index + 1}`][0].focus();
                });
            }
            if (this.otpFields.join('').length === 6) {
                this.$nextTick(() => {
                    // this.verifyOtp();
                });
            }
        },
        onFocus(index) {
            this.formErrors = new Error({});
        },
        async verifyOtp() {

            this.loader = true;
            if (!this.recaptchaToken) {
                this.captchaError = 'Please complete the captcha.';
                return;
            }
            const otp = this.otpFields.join('');
            try {
                const response = await request({
                    method: 'post',
                    url: `auth/verify-otp`,
                    data: { otp,
                        email: this.email,
                        captcha: this.recaptchaToken,
                    },
                });

                const { data } = response;
                await this.redirectingUserPage(data);
            } catch (error) {
                this.failedAttempts += 1;

                if (this.failedAttempts >= 3) {
                    this.notifyErrorWithMsg('You have exceeded the maximum number of OTP attempts. Please try logging in again');
                    setTimeout(() => {
                        this.$router.push({ name: "Login" });
                    }, 2000);
                    return;
                }
                this.resetCaptcha();
                if (error.response && error.response.status === 422) {
                    this.formErrors = new Error(error.response.data.errors);
                } else {
                    this.clearOtp();
                    this.notifyError();
                }
            } finally {
                this.loader = false;
            }
        },
        async resendOtp() {
            this.otpFields = Array(6).fill('');  // Reset OTP fields

            try {
                await request({
                    method: 'post',
                    url: `auth/resend-otp`,
                    data: { email: this.email },
                });

                this.$bvToast.toast('OTP has been resent!', { variant: 'success', solid: true });
                this.startCountdown();
            } catch (error) {
                this.notifyError();
            }
        },
        startCountdown() {
            this.countdown = 180;
            this.interval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.interval);
                }
            }, 1000);
        },
        onPaste(event) {
            event.preventDefault();
            const pastedData = event.clipboardData.getData('text').trim();
            if (/^\d{6}$/.test(pastedData)) {
                this.otpFields = pastedData.split('');
                this.$nextTick(() => {
                    this.$refs[`otp-5`][0].focus();
                    // this.verifyOtp();
                });
            }
        }
    },
    mounted() {
        this.startCountdown();
        this.$nextTick(() => {
            this.$refs['otp-0'][0]?.focus();
        });
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/enterprise.js';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
        window.onRecaptchaSuccess = this.onVerify;
        window.onRecaptchaError = this.onError;
        window.onRecaptchaExpired = this.onExpired;
    },
    beforeUnmount() {
        clearInterval(this.interval);
    }
};
</script>

<style scoped>
.otp-input {
    width: 50px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    margin: 0 5px;
    border-radius: 8px;
    border: 1px solid #ccc;
}

.otp-input:focus {
    border-color: #007bff;
}

.d-flex {
    display: flex;
    justify-content: center;
}
</style>
